import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateUploadTransferJobMutationVariables = Types.Exact<{
  batchItemId: Types.Scalars['ID']['input'];
  filePaths: Array<Types.Scalars['String']['input']>;
  originalFileNames?: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type CreateUploadTransferJobMutation = { __typename?: 'Mutation', createUploadTransferJob?: { __typename?: 'CreateUploadTransferJobPayload', id: string, name: string, assets: Array<{ __typename?: 'TransferJobAsset', id: number, filesize?: number | null, fileType?: string | null, name?: string | null, type?: string | null }> } | null };


export const CreateUploadTransferJob = /*#__PURE__*/ gql`
    mutation CreateUploadTransferJob($batchItemId: ID!, $filePaths: [String!]!, $originalFileNames: [String!]) {
  createUploadTransferJob(
    batchItemId: $batchItemId
    filePaths: $filePaths
    originalFileNames: $originalFileNames
  ) {
    id
    name
    assets {
      id
      filesize
      fileType
      name
      type
    }
  }
}
    ` as unknown as DocumentNode<CreateUploadTransferJobMutation, CreateUploadTransferJobMutationVariables>;

          

          export const useCreateUploadTransferJobMutation = (options?:MutationHookOptions<CreateUploadTransferJobMutation, CreateUploadTransferJobMutationVariables>) => useMutation(CreateUploadTransferJob, options);
          

          export type CreateUploadTransferJobMutationOptions = MutationHookOptions<CreateUploadTransferJobMutation, CreateUploadTransferJobMutationVariables>;

          

          export type CreateUploadTransferJobMutationResult = ReturnType<typeof useCreateUploadTransferJobMutation>[1];

          
